import { toast } from 'react-hot-toast';

import { getItem } from '../helpers/store';

export const EXTENSION_ID = 'ibgcbgjnpaedoomkhclbjgnhnkmeplee';
export const EXTENSION_URL = `https://chrome.google.com/webstore/detail/getro/${EXTENSION_ID}`;

export const checkExtensionAvailability = () =>
  new Promise((resolve, reject) => {
    setTimeout(() => reject(), 1000);
    // eslint-disable-next-line no-undef
    if (typeof chrome !== 'undefined' && chrome?.runtime?.sendMessage) {
      // eslint-disable-next-line no-undef
      chrome.runtime.sendMessage(EXTENSION_ID, { type: 'VERSION' }, (response) => {
        if (!response) {
          // eslint-disable-next-line no-undef
          reject(chrome.runtime.lastError);
        }

        resolve(true);
      });
    } else {
      reject();
    }
  });

export const launchScraper = (network, user) => {
  // eslint-disable-next-line no-undef
  if (typeof chrome !== 'undefined' && chrome?.runtime?.sendMessage) {
    // eslint-disable-next-line no-undef
    chrome.runtime.sendMessage(
      EXTENSION_ID,
      {
        type: 'SCRAPER_INITIALIZE',
        auth: getItem('authToken'),
        user: {
          avatarUrl: user.avatarUrl,
          email: user.email,
          id: user.id,
          fullName: `${user.firstName} ${user.lastName}`,
        },
        networkId: network.id,
      },
      (response) => {
        if (response?.type === 'SEND_COOKIES_SUCCESS') {
          toast('Contacts successfully imported', { icon: 'success', id: 'export-csv-success' });
        }
      },
    );
  }
};

// Hands the current platform JWT to the extension so it can re-authenticate
// itself: the extension stores the token and its heartbeat re-bootstraps a
// refresh token. This recovers a stuck extension (lost token + cookie fallback
// that can't cross getro.findem.ai -> api.getro.com) without a LinkedIn sync.
// Side-effect-free on the extension side. No-ops without a stored token, or
// when the extension is absent or predates the AUTHENTICATE handler (which
// replies with an unknown-type error). See GET-440.
export const authenticateExtension = (user, networkId) => {
  const auth = getItem('authToken');

  // eslint-disable-next-line no-undef
  if (!auth || typeof chrome === 'undefined' || !chrome?.runtime?.sendMessage) {
    return;
  }

  // eslint-disable-next-line no-undef
  chrome.runtime.sendMessage(
    EXTENSION_ID,
    {
      type: 'AUTHENTICATE',
      auth,
      user: {
        avatarUrl: user.avatarUrl,
        email: user.email,
        id: user.id,
        fullName: `${user.firstName} ${user.lastName}`,
      },
      networkId,
    },
    // Reading lastError suppresses the "Unchecked runtime.lastError" warning
    // emitted when the extension isn't installed; nothing else to do.
    // eslint-disable-next-line no-undef
    () => chrome.runtime.lastError,
  );
};

export const signOutBrowserExtension = () => {
  // eslint-disable-next-line no-undef
  if (typeof chrome !== 'undefined' && chrome?.runtime?.sendMessage) {
    // eslint-disable-next-line no-undef
    chrome.runtime.sendMessage(EXTENSION_ID, { type: 'SIGN_OUT' }, () => {});
  }
};
